import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=b371b6da&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b371b6da')) {
      api.createRecord('b371b6da', component.options)
    } else {
      api.reload('b371b6da', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=b371b6da&", function () {
      api.rerender('b371b6da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2DnNbf2NNTfwz/JS/comp/ErrorMessage.vue"
export default component.exports